import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var BugIcon = function BugIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "BugIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.007 3.45c-.702 0-1.274.556-1.3 1.252h2.6a1.3 1.3 0 0 0-1.3-1.252m0-1.45a2.75 2.75 0 0 0-2.75 2.704h-.005a.7.7 0 0 0-.234.057L2.994 3.466a.725.725 0 0 0-.782 1.22l2.003 1.282c-.176.458-.28.943-.309 1.436H1.725a.725.725 0 1 0 0 1.45h2.18v.626q.001.522.124 1.007L2.232 11.56a.725.725 0 0 0 .743 1.245l1.658-.99a4.1 4.1 0 0 0 3.374 1.768c1.399 0 2.634-.7 3.374-1.768l1.659.99a.725.725 0 1 0 .743-1.245l-1.797-1.073a4 4 0 0 0 .124-1.007v-.626h2.146a.725.725 0 1 0 0-1.45h-2.148a4.8 4.8 0 0 0-.308-1.436l2.002-1.281a.725.725 0 0 0-.781-1.221L10.996 4.76a.7.7 0 0 0-.238-.057A2.75 2.75 0 0 0 8.008 2M5.718 6.152c-.21.41-.335.86-.363 1.323V9.48c0 1.214.815 2.237 1.927 2.553V8.805a.725.725 0 1 1 1.45 0v3.228A2.654 2.654 0 0 0 10.66 9.48V7.475a3.3 3.3 0 0 0-.364-1.323z",
      clipRule: "evenodd"
    })
  }));
};

export { BugIcon };
